$mol_embed_native $mol_scroll
	dom_name \iframe
	window null
	attr *
		^
		src <= uri? \about:config
	sub /
		<= Fallback $mol_link
			uri <= uri
			sub /
				<= title \
	message *
		hashchange? <=> uri_change? null
